import { useRef } from "react";
import { Link } from "react-router-dom";
import { Page } from "../../../../components/page/page";
import { useLocalization } from "../../../../hooks/use-localization/useLocalization";
import { useUser } from "../../../../hooks/use-user/useUser";
import { Form } from "../../../../components/form/form";
import { PasswordInput } from "../../../../components/input/passwordInput";

export const Password: React.FC = () => {
  const { user } = useUser();
  const { localize } = useLocalization();
  const passwordRef = useRef<HTMLInputElement>(null);
  const confirmPasswordRef = useRef<HTMLInputElement>(null);

  function validatePassword() {
    const password = passwordRef.current;
    const confirmPassword = confirmPasswordRef.current;

    if (!password || !confirmPassword) {
      return;
    }

    if (password.value !== confirmPassword.value) {
      confirmPassword.setCustomValidity(localize("register:passwordMismatch"));
    } else {
      confirmPassword.setCustomValidity("");
    }
  }

  if (!user) {
    return null;
  }

  return (
    <Page title={localize("admin:changePassword")}>
      <Form
        action="/change-password"
        method="POST"
        actionLabel={localize("save")}
        successMessage={localize("saved")}
      >
        <PasswordInput
          label={
            <>
              {localize("admin:oldPassword")}
              <a href="/">{localize("login:forgotPassword")}</a>
            </>
          }
          name="oldPassword"
          autoComplete="current-password"
          required
        />
        <PasswordInput
          label={localize("admin:newPassword")}
          ref={passwordRef}
          name="newPassword"
          autoComplete="new-password"
          required
          onChange={validatePassword}
        />
        <PasswordInput
          label={localize("register:confirmPassword")}
          ref={confirmPasswordRef}
          name="confirmPassword"
          autoComplete="new-password"
          required
          onChange={validatePassword}
        />
      </Form>
      <Link className="button secondary" to="../" relative="path">
        {localize("back")}
      </Link>
    </Page>
  );
};
